module.exports = __webpack_public_path__ + "static/media/validatePhoneNumber.c9c6daed.svg";